export default __webpack_public_path__ + "static/media/260f9d6a3ae351261fa45891ed3c3e3b.svg";